import type { IconData } from '@stacksjs/iconify-core'

export const vpnConnection: IconData = {
  "body": "<g fill=\"none\" stroke=\"currentColor\" stroke-linecap=\"round\" stroke-linejoin=\"round\" stroke-width=\"3\"><path d=\"M3.406 10.107c.062-1.047.933-1.85 1.98-1.92c6.667-.444 13.699-3.09 16.876-4.422a4.5 4.5 0 0 1 3.476 0c3.177 1.332 10.209 3.978 16.876 4.422c1.047.07 1.918.873 1.98 1.92c.155 2.585.406 7.44.406 11.793c0 1.08-.03 2.16-.082 3.209c-.296 6.063-3.59 11.538-8.746 14.744C32.007 42.444 27.109 45 24 45s-8.007-2.556-12.172-5.147c-5.155-3.206-8.45-8.68-8.746-14.744A66 66 0 0 1 3 21.9c0-4.353.25-9.208.406-11.793\"/><path d=\"M12 20c6.627-8 17.373-8 24 0\"/><path d=\"M16 25c4.418-5.333 11.582-5.333 16 0m-11 6a3 3 0 1 0 6 0a3 3 0 1 0-6 0\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default vpnConnection
